import { Route } from 'react-router-dom';
import { Container } from '@material-ui/core';
import SampleClient from "../service/Tenants/SampleClient";
import M3tas from '../service/Tenants/M3tas';
import RDCorretora from '../service/Tenants/RDCorretora';
import Coruja from '../service/Tenants/Coruja';
import RBMSeguros from '../service/Tenants/RBMSeguros';
import HectaresSeguros from '../service/Tenants/HectaresSeguros';
import CanolaSeguros from '../service/Tenants/CanolaSeguros';
import Default from '../service/Tenants/Default';

import CorujaClube from '../service/Tenants/CorujaClube';
import FranquiaA from '../service/Tenants/Tests/FranquiaA';
import FranquiaB from '../service/Tenants/Tests/FranquiaB';
import FranquiaC from '../service/Tenants/Tests/FranquiaC';
import FranquiaD from '../service/Tenants/Tests/FranquiaD';
import FranquiaE from '../service/Tenants/Tests/FranquiaE';

export const TenantRoutes = () => 
(
    <Container>
        <Route path="/default" component={Default} />
        <Route path="/m3tas" component={M3tas} />
        <Route path="/sampleclient" component={SampleClient} />
        <Route path="/rdgo" component={RDCorretora} />
        <Route path="/rbmseguros" component={RBMSeguros} />
        <Route path="/hectaresseguros" component={HectaresSeguros} />
        <Route path="/canolaseguros" component={CanolaSeguros} />
        
        {/* Ambientes Coruja */}
        <Route path="/coruja" component={Coruja} />
        <Route path="/corujaclube" component={CorujaClube} />
        {/* Teste das Franquias */}
        <Route path="/franquiaa" component={FranquiaA} />
        <Route path="/franquiab" component={FranquiaB} />
        <Route path="/franquiac" component={FranquiaC} />
        <Route path="/franquiad" component={FranquiaD} />
        <Route path="/franquiae" component={FranquiaE} />
    </Container>
);

export function GetTenantRoute() 
{
    const tenantId = localStorage.getItem("tenantId");

    if (tenantId) {
        const tenantRote = localStorage.getItem("tenantId")
            .replace("rdcorretora", "rdgo");
        return tenantRote;
    }

    return "default";
}


